jQuery(document).ready(function () {
  window.component = jQuery(".slider-container");
  if (window.component && window.component.length) {
    window.sourceDepths = [];
    window.dragSources = window.component.find("#target");
    window.currentSource = null;
    window.startDragY = 0;
    window.startMouseY = 0;
    window.previousRatio = 0;

    var sourcesOffset = window.component.find(".image-container").offset();

    for (var i = 0; i < window.dragSources.length; i++) {
      var sourceObj = jQuery(window.dragSources[i]);
      if (sourceObj) {
        sourceObj.data("startX", sourceObj.offset().left - sourcesOffset.left);
        sourceObj.data("startY", sourceObj.offset().top - sourcesOffset.top);
        window.sourceDepths.push(sourceObj);
      }
    }

    window.dragSources.on("mousedown touchstart", window.onSourceDown);
    jQuery(window).on("resize", window.handleResize);

    // TOOD: check touchstart is good!
    jQuery(".right-text .slide-handler, .slide-left").on(
      "click touchstart",
      function () {
        handleClickAnimation("left", "propel");
      }
    );

    jQuery(".left-text .slide-handler, .slide-right").on(
      "click touchstart",
      function () {
        handleClickAnimation("right", "revive");
      }
    );

    // back to center click handler
    jQuery("#back-to-center").on("click", function () {
      handleReturnToCenter();
    });

    setBoxWidths();
    // run a function to move it if the url has a product in it
    checkActiveProduct();
  }
});

function checkActiveProduct() {
  const hash = window.location.hash;

  if (hash.length) {
    if (hash === "#propel") {
      handleClickAnimation("left", "propel");
    } else if (hash === "#revive") {
      handleClickAnimation("right", "revive");
    }
  }
}

function handleClickAnimation(direction, productName) {
  handleImageUpdate(productName);
  var maxWidth = window.component.find(".image-container").width();
  // let slidePos = maxWidth / 2;

  const startPosition = jQuery(".slide-bar").position().left;
  let progress = 0;
  // const easing = BezierEasing(0.47, 0, 0.745, 0.715);
  // ease-in?
  // const easing = BezierEasing(0.42, 0.02, 1, 1);
  // ease-in-out
  const easing = BezierEasing(0.42, 0, 0.58, 1);

  const PIXELS_TO_MOVE = 10;

  let start, previousTimeStamp;
  // let done = false;

  function step(timestamp) {
    if (start === undefined) {
      start = timestamp;
    }
    const elapsed = timestamp - start;

    let newPos;

    if (direction === "left") {
      newPos = jQuery(".slide-bar").position().left - PIXELS_TO_MOVE;
      // let newPos = jQuery(".slide-bar").offset().left - PIXELS_TO_MOVE;
    } else {
      newPos = jQuery(".slide-bar").position().left + PIXELS_TO_MOVE;
      // let newPos = jQuery(".slide-bar").offset().left - PIXELS_TO_MOVE;
    }

    progress += PIXELS_TO_MOVE;
    // this now needs to be turned back into the position

    let relativeProgressInPx;

    if (direction === "left") {
      const relativeProgress = progress / startPosition;

      const easedProgress = easing(relativeProgress);

      relativeProgressInPx = startPosition - startPosition * easedProgress;
    } else {
      // this is how far it needs to travel
      const distanceToMove = maxWidth - startPosition;

      const relativeProgress = progress / distanceToMove;

      const easedProgress = easing(relativeProgress);

      relativeProgressInPx = startPosition + distanceToMove * easedProgress;
    }

    if (direction === "left") {
      if (newPos < 0) {
        newPos = 0;
      }
    } else {
      if (newPos > maxWidth) {
        newPos = maxWidth;
      }
    }

    if (previousTimeStamp !== timestamp) {
      window.component.find(".slide-bar").css("left", relativeProgressInPx);
      window.onSourceMove(maxWidth, maxWidth);
    }

    // * set to this as the function below put the position to 2 if it is less than that
    if (direction === "left") {
      if (newPos > 2) {
        window.requestAnimationFrame(step);
      }
    } else {
      if (newPos < maxWidth - 2) {
        window.requestAnimationFrame(step);
      }
    }
  }

  window.requestAnimationFrame(step);
}

function handleReturnToCenter() {
  var maxWidth = window.component.find(".image-container").width();
  let halfWidth = maxWidth / 2;

  const startPosition = jQuery(".slide-bar").position().left;

  const direction = startPosition > halfWidth ? "left" : "right";
  let progress = 0;
  const easing = BezierEasing(0.42, 0, 0.58, 1);

  const PIXELS_TO_MOVE = 10;

  let start, previousTimeStamp;
  // let done = false;

  function step(timestamp) {
    if (start === undefined) {
      start = timestamp;
    }
    const elapsed = timestamp - start;

    let newPos;

    if (direction === "left") {
      newPos = jQuery(".slide-bar").position().left - PIXELS_TO_MOVE;
    } else {
      newPos = jQuery(".slide-bar").position().left + PIXELS_TO_MOVE;
    }

    progress += PIXELS_TO_MOVE;
    // this now needs to be turned back into the position

    let relativeProgressInPx;

    if (direction === "left") {
      const relativeProgress = progress / startPosition;

      const easedProgress = easing(relativeProgress);

      relativeProgressInPx = startPosition - startPosition * easedProgress;
    } else {
      // this is how far it needs to travel
      // const distanceToMove = maxWidth - startPosition;
      const distanceToMove = halfWidth - startPosition;

      const relativeProgress = progress / distanceToMove;

      const easedProgress = easing(relativeProgress);

      relativeProgressInPx = startPosition + distanceToMove * easedProgress;
    }

    if (direction === "left") {
      if (newPos < halfWidth) {
        newPos = halfWidth;
      }
    } else {
      if (newPos > halfWidth) {
        newPos = halfWidth;
      }
    }

    if (previousTimeStamp !== timestamp) {
      window.component.find(".slide-bar").css("left", relativeProgressInPx);
      window.onSourceMove(maxWidth, maxWidth);
    }

    if (newPos !== halfWidth) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

/**
 *
 * @param {*} downEvent
 */
window.onSourceDown = function (downEvent) {
  downEvent.preventDefault();
  downEvent.stopPropagation();

  var eventPosition = downEvent;
  var sourceObj = jQuery(downEvent.currentTarget);
  {
    try {
      if (event && event.touches) eventPosition = event.touches[0];
    } catch (e) {}

    window.currentSource = sourceObj;
    window.startDragX = window.currentSource.offset().left;
    window.startMouseX = eventPosition.clientX;

    window.component.on("mousemove touchmove", window.onSourceMove);
    window.component.on("mouseup touchend", window.onSourceUp);
  }
};

window.onSourceMove = function (moveEvent, maxWidth) {
  var minWidth = 0;
  if (!maxWidth) {
    maxWidth = window.component.find(".image-container").width();
  } else {
    maxWidth = maxWidth;
  }

  var newPosition = jQuery(".slide-bar").position().left;
  var eventPosition = moveEvent;
  var leftText = window.component.find(".left-text");
  var rightText = window.component.find(".right-text");
  // TODO: move other selectors here

  const backToCenterButton = window.component.find("#back-to-center");

  try {
    if (event && event.touches) eventPosition = event.touches[0];
  } catch (e) {}

  // * added to make the maths easier
  const ratio = newPosition / maxWidth;

  if (newPosition < minWidth) {
    // TODO: remove this stuff?
    window.component.off("mousemove touchmove");
    window.component.off("mouseup touchend");

    // TODO: what do these do?
    // jQuery(".slide-image").css("width", minWidth + 2);
    jQuery(".slide-image").css("width", minWidth + 1);
    jQuery(".slide-bar").css({
      // left: minWidth + 2,
      left: minWidth + 1,
    });
  } else if (newPosition >= maxWidth) {
    window.component.off("mousemove touchmove");
    window.component.off("mouseup touchend");

    // jQuery(".slide-image").css("width", maxWidth - 2);
    jQuery(".slide-image").css("width", maxWidth - 1);
    jQuery(".slide-bar").css({
      // left: maxWidth - 2,
      left: maxWidth - 1,
    });
  } else {
    window.component.find(".slide-bar").offset({
      left:
        // TODO: what is this magic number of 35?
        window.startDragX + (eventPosition.clientX - window.startMouseX + 35),
    });

    window.component.find(".slide-image").css("width", newPosition);

    if (ratio > 0.55) {
      if (leftText.hasClass("fade-out")) {
        leftText.removeClass("fade-out").addClass("fade-in");
      }

      if (rightText.hasClass("fade-in")) {
        rightText.removeClass("fade-in").addClass("fade-out");
      } else {
        rightText.addClass("fade-out");
      }

      if (ratio > 0.95) {
        if (jQuery(".left-text-two").hasClass("fade-out")) {
          jQuery(".left-text-two").removeClass("fade-out").addClass("fade-in");
        } else {
          jQuery(".left-text-two").addClass("fade-in");
        }

        leftText.addClass("fully-active");

        const button = jQuery(leftText).find(".button.slide-handler");
        // jQuery(button).addClass("fading").fadeOut();
        jQuery(button).addClass("fading");
        setTimeout(function () {
          jQuery(button).addClass("faded");
        }, 300);

        if (ratio > window.previousRatio) {
          backToCenterButton.addClass("visible").addClass("right");
        }
        handleImageUpdate("revive");
      }
      // * just used to be else, with this need to show them when between
    } else if (ratio < 0.45) {
      if (rightText.hasClass("fade-out")) {
        rightText.removeClass("fade-out").addClass("fade-in");
      }
      if (leftText.hasClass("fade-in")) {
        leftText.removeClass("fade-in").addClass("fade-out");
      } else {
        leftText.addClass("fade-out");
      }

      if (ratio < 0.05) {
        if (jQuery(".right-text-two").hasClass("fade-out")) {
          jQuery(".right-text-two").removeClass("fade-out").addClass("fade-in");
        } else {
          jQuery(".right-text-two").addClass("fade-in");
        }

        rightText.addClass("fully-active");

        const button = jQuery(rightText).find(".button.slide-handler");
        // jQuery(button).addClass("fading").fadeOut();
        jQuery(button).addClass("fading");
        setTimeout(function () {
          jQuery(button).addClass("faded");
        }, 300);

        if (ratio < window.previousRatio) {
          backToCenterButton.addClass("visible").addClass("left");
        }
        handleImageUpdate("propel");
      }
    }

    if (ratio > 0.48 && ratio < 0.5) {
      if (leftText.hasClass("fade-out")) {
        leftText.removeClass("fade-out").addClass("fade-in");
      }
    } else if (ratio < 0.52 && ratio > 0.5) {
      if (rightText.hasClass("fade-out")) {
        rightText.removeClass("fade-out").addClass("fade-in");
      }
    }

    // for near the end
    if (ratio < 0.95) {
      if (jQuery(".left-text-two").hasClass("fade-in")) {
        jQuery(".left-text-two").removeClass("fade-in").addClass("fade-out");
      }
      leftText.removeClass("fully-active");

      const button = jQuery(leftText).find(".button.slide-handler");
      // jQuery(button).removeClass("fading").fadeIn();
      jQuery(button).removeClass("faded");
      setTimeout(function () {
        jQuery(button).removeClass("fading");
      }, 50);

      if (ratio < window.previousRatio && ratio > 0.1) {
        if (backToCenterButton.hasClass("visible")) {
          backToCenterButton.removeClass("visible").removeClass("right");
        }
      }
    }
    if (ratio > 0.05) {
      if (jQuery(".right-text-two").hasClass("fade-in")) {
        jQuery(".right-text-two").removeClass("fade-in").addClass("fade-out");
      }
      rightText.removeClass("fully-active");

      const button = jQuery(rightText).find(".button.slide-handler");
      // jQuery(button).removeClass("fading").fadeIn();
      jQuery(button).removeClass("faded");
      setTimeout(function () {
        jQuery(button).removeClass("fading");
      }, 50);

      if (ratio > window.previousRatio && ratio < 0.9) {
        if (backToCenterButton.hasClass("visible")) {
          backToCenterButton.removeClass("visible").removeClass("left");
        }
      }
    }
  }
  window.previousRatio = ratio;
};

window.onSourceUp = function (upEvent) {
  window.component.off("mousemove touchmove");
  window.component.off("mouseup touchend");
  var targetObj;
};

// TODO: debounce?
// * function was taken from here and moved straight to the replacement
window.handleResize = function (e) {
  setBoxWidths();
};

function setBoxWidths() {
  var maxWidth = window.component.find(".image-container").width();
  // TODO: check why maxWidth is passed to this twice
  window.onSourceMove(maxWidth, maxWidth);
  jQuery(".left-text, .right-text, .left-text-two, right-text-two").css(
    "width",
    maxWidth / 2
  );
  jQuery(".left-text, .right-text, .left-text-two, right-text-two").css(
    "max-width",
    maxWidth / 2
  );

  jQuery(".left-text-two").css("left", maxWidth / 2);
  jQuery(".right-text-two").css("right", maxWidth / 2);
}

function handleImageUpdate(activeProduct) {
  const productImageBlocks = document.querySelectorAll(
    ".image-content-left-right--products"
  );

  if (productImageBlocks && productImageBlocks.length) {
    productImageBlocks.forEach((productImageBlock) => {
      if (productImageBlock.classList.contains(activeProduct)) {
        return;
      }

      productImageBlock.classList.remove("revive");
      productImageBlock.classList.remove("propel");

      productImageBlock.classList.add(activeProduct);
    });
  }

  const yaywImageBlocks = document.querySelectorAll(".airpod-your-way__main");
  const yaywScrollBlockRevive = document.querySelector(
    ".section-scroll__main-scroller[data-product=revive]"
  );
  const yaywScrollBlockPropel = document.querySelector(
    ".section-scroll__main-scroller[data-product=propel]"
  );

  // check which one is meant to be active and move it to the top of the parent selector
  if (yaywImageBlocks && yaywImageBlocks.length) {
    yaywImageBlocks.forEach((yaywImageBlock) => {
      if (yaywImageBlock.dataset.product === activeProduct) {
        const activeMains = document.querySelectorAll(
          ".airpod-your-way__main.current-active"
        );
        if (activeMains && activeMains.length) {
          activeMains.forEach((other) =>
            other.classList.remove("current-active")
          );
        }
        yaywImageBlock.classList.add("current-active");

        if (yaywImageBlock.dataset.product === "propel") {
          const parentNode = yaywScrollBlockPropel.parentNode;
          parentNode.insertBefore(yaywScrollBlockPropel, yaywScrollBlockRevive);
        } else {
          const parentNode = yaywScrollBlockRevive.parentNode;
          parentNode.insertBefore(yaywScrollBlockRevive, yaywScrollBlockPropel);
        }

        const highlight = document.querySelector(
          ".airpod-your-way .section-scroll__navigation-underline"
        );
        const nextActiveLink = document.querySelector(
          `.airpod-your-way .section-scroll__navigation-item[data-product="${yaywImageBlock.dataset.product}"]`
        );
        const currentActive = document.querySelector(
          ".airpod-your-way .section-scroll__navigation-item.active"
        );

        console.log("currentActive currentActive currentActive", currentActive);
        if (currentActive) {
          currentActive.classList.remove("active");
        }

        nextActiveLink.classList.add("active");

        // TODO: link highlight logic
        highlightLink(nextActiveLink, highlight);
      }
    });
  }
}
